// Copied from transition-web/src/hooks/useLogout.tsx
import { signOut } from 'firebase/auth'
import { useQueryClient } from '@tanstack/react-query'
import { auth } from '../libs/Firebase'
import useAppState, { DEFAULT_STATE } from './useAppState'
import onUnhandledPromiseRejection from '../libs/onUnhandledPromiseRejection'

export function useLogout(onLogout?: () => void) {
  const { setState } = useAppState()
  const queryClient = useQueryClient()

  return () => {
    onLogout?.()

    // Clear all app state

    setState(DEFAULT_STATE)

    // Clear React Query cache to prevent data leakage between users

    queryClient.clear()

    // Clear any cached tokens or local storage
    try {
      // Preserve the dev-only AI-agent-testing toggle across logout. It is a browser/session
      // testing flag (set from `?agentMode=true`), NOT user data — clearing it here silently
      // disabled the whole agent layer on the next page load (no `__agentGameApi`, no
      // `agentControl` on the game iframe), so agent-driven game commands did nothing.
      const agentMode = localStorage.getItem('intraction_agent_mode')
      localStorage.clear()
      sessionStorage.clear()
      if (agentMode !== null) localStorage.setItem('intraction_agent_mode', agentMode)
    } catch (error) {}

    return signOut(auth).catch(onUnhandledPromiseRejection)
  }
}
